/**
 * Messages FR pour les boîtes de dialogue
 */

module.exports = {

    role: {
        remove: {
            title: 'Are you sure you want to delete the role { name } ? Users with this role will no longer have authorization.',
            altLabel: 'Delete the role { name }.',
            error: 'An error occurred while deleting the role { name }.',
            button: {
                confirm: 'Delete',
                cancel: 'Cancel'
            }
        }
    },

    // Modale des tutorials vidéos
    tutorialVideoTree: {
        title: 'Videos tutorials',
        empty: 'No tutorial video available.',
        takeMeetButton: {
            label: 'Need to chat with a professional via video?'
        },
        search: {
            fields: {
                search: 'Searching a tutorial'
            }
        }
    },

    user: {
        requiredSubscription: {
            message: 'To use this feature, you need a subscription. We look forward to seeing you!',
            messageWithSubscriptionTarget: 'To use this feature, you must have a { productName } subscription.',
            button: {
                confirm: 'Subscribe'
            }
        },
        sendRegistrationValidation: {
            altLabel: 'Send a notification requesting validation of your registration to { name }.',
            title: 'Send a registration validation request',
            content: 'Would you like to send a registration validation request to { name } ?',
            error: 'An error occurred while sending the notification to { name }.',
            button: {
                confirm: 'Send',
                cancel: 'Cancel'
            }
        },
        sendConnectionInvitation: {
            title: 'Send an e-mail?',
            content: {
                init: 'Would you like to send an e-mail instruction to { name } to initialize his password ?',
                login: 'Would you like to send an e-mail instruction for { name } to connect?'
            },
            altLabel: 'Invite { name } to connect.',
            error: 'An error occurred while sending the email to { name }.',
            button: {
                confirm: 'Send',
                cancel: 'Cancel'
            }
        },
        impersonate: {
            title: 'Connect ?',
            content: 'Would you like to impersonate the account of { name } ?',
            altLabel: 'Log in to your { name }.',
            error: 'An error occurred while trying to connect to the { name }.',
            button: {
                confirm: 'Connect',
                cancel: 'Cancel'
            }
        },
        editRole: {
            title: 'Editing the role of { user }'
        },
        delete: {
            title: 'Are you sure?',
            content: 'Are you sure you want to delete <strong>{ name }</strong> ?',
            altLabel: 'Delete an account { name }.',
            error: 'An error occurred during deletion of { name }.',
            button: {
                confirm: 'Delete an account',
                cancel: 'Cancel'
            }
        },
        resetPassword: {
            title: 'Reset password'
        }
    },

    contact: {
        remove: {
            title: 'Are you sure?',
            content: 'Are you sure you want to delete { name } from your contacts?',
            altLabel: 'Delete an account of { name }.',
            error: 'An error occurred during deletion of { name }.',
            button: {
                confirm: 'Delete',
                cancel: 'Cancel'
            }
        }
    },

    admin: {
        taskConfiguration: {
            edit: {
                title: 'Task configuration { name }'
            },
            group: {
                add: {
                    title: 'Create a task configuration group'
                },
                edit: {
                    title: 'Edit a group { name }'
                },
                taskConfigurations: {
                    title: 'Edition of group task configurations { group }'
                }
            }
        },
        video: {
            create: {
                title: 'Add a video'
            },
            edit: {
                title: 'Edit a video { video }'
            },
            import: {
                title: 'Videos Import'
            },
            tutorial: {
                category: {
                    create: {
                        title: 'Create a video category'
                    },
                    edit: {
                        title: 'Edit the { category } category'
                    }
                },
                question: {
                    create: {
                        title: 'Create a tutorial question'
                    },
                    edit: {
                        title: 'Edit the { question } question'
                    }
                },
                video: {
                    create: {
                        title: 'Create a tutorial video'
                    },
                    edit: {
                        title: 'Edit the { video } video'
                    },
                    remove: {
                        error: 'An error occurred while deleting the { video } video.',
                        message: 'Are you sure you want to delete the { video } video?'
                    }
                }
            }
        },
        publicationIdea: {
            create: {
                title: 'Add an idea for publication'
            },
            edit: {
                title: 'Edit a publication idea { idea }'
            },
            import: {
                title: 'Import of publication ideas'
            }
        },
        graphicalLineTemplate: {
            create: {
                title: 'Add a graphic chart',
                choiceType: {
                    description: 'Choose a charter type',
                    types: {
                        single: 'Single picture',
                        carousel: 'Carousel'
                    }
                }
            },
            edit: {
                title: 'Edit a chart',
                editVisualButton: {
                    label: 'Edit the visual'
                }
            },
            remove: {
                message: 'Are you sure you want to delete the graphic chart { name } ?',
                error: 'An error occurred while deleting the graphic chart { name }.'
            }
        },
        agencyManager: {
            customerList: {
                title: 'Customer list',
            },
            affiliationCode: {
                add: {
                    title: 'Add an affiliate code'
                },
                edit: {
                    title: 'Editing the affiliation code { code }'
                }
            }
        }
    },

    socialNetwork: {
        connectionError: 'An error occurred while connecting to the social network {network}. If the problem persists, please contact our <a href="{ contactUrl }" title="">technical support by clicking here</a> or by e-mail to <a href="{ contactUrl }" title="">{ contactMail }</a>.',
        selectAccounts: {
            title: 'Linking accounts { network }',
            description: 'Select at least 1 account to associate',
            empty: 'No account associated with your profile { network } was found.',
            error: 'An error occurred while linking the account.',
            confirmationCloseModal: {
                message: 'You must select at least one page from the list to use a network.'
            }
        },
        addNetworks: {
            button: {
                altTitle: 'Add a network.'
            },
            title: 'Adding a network'
        },
        howUnlink: {
            title: 'How can I unlink { applicationName } from my social networks?',
            instructions: {
                facebook: 'To unlink your Facebook and Instagram social networks from the application { applicationName }, go to your Facebook account, click on your profile picture and go to "Settings and Privacy", then in "Parameters" and finally in "Professional integrations" to delete the application { applicationName } :',
                linkedin: 'To unlink your LinkedIn account from the application { applicationName }, you need to go to your LinkedIn account, click on your profile picture and go to "Settings & Privacy", then to "Data privacy" and finally to "Other applications" and "Permitted services" to delete the application { applicationName } :',
                after: 'Once deleted, you can return to the application { applicationName } in "My profile" tab "Essential information" and reconnect your account.'
            }
        },
        editTone: {
            title: 'Tone customization'
        },
        higherSubscriptionLevelRequired: {
            message: {
                withSubscription: 'You need a higher-level subscription to add a network.',
                withoutSubscription: 'You need a subscription to add a network.'
            },
            buttons: {
                subscribe: 'Subscribe',
                changeSubscription: 'Change subscription'
            }
        }
    },

    confirmation: {
        title: 'Are you sure ?',
    },

    // Tâche
    task: {
        add: {
            title: 'Add a publication',
            aiPublicationWithFiles: {
                title: 'Generate a post from an image'
            },
            buttons: {
                orderPublication: {
                    label: 'Order a publication'
                },
                addPublication: {
                    label: 'Via my info'
                },
                addAIPublication: {
                    standard: {
                        label: 'Via a prompt'
                    },
                    event: {
                        label: 'Via an URL'
                    }
                },
                addAiPublicationWithFiles: {
                    label: 'Via image'
                }
            }
        },
        remove: {
            message: 'Are you sure you want to delete the publication { title } ?',
            error: 'An error occurred while deleting the publication.'
        },
        validate: {
            title: 'Schedule the post',
            description: 'Check the social network accounts on which to publish the task.',
            error: 'An error occurred during task validation.',
            subscriptionRequired: 'You must now be a subscriber to continue scheduling posts.',
            multipleNetworksHooks: 'You have different texts for your networks. If you want to change them, you can do so by closing this dialog box.',
            buttons: {
                cancelPublications: {
                    label: 'Unschedule the post'
                }
            }
        },
        // Demande de régénération complète par l'IA
        regenerateSuggestion: {
            title: 'Complete regeneration request via AI',
            credits: 'A complete regeneration will use { credits } credits.'
        },
        editSuggestion: {
            title: 'Editing parameters of the task { title }',
            error: 'An error occurred while saving the task'
        },
        convertSuggestionInReturn: {
            title: 'Before you request a return',
            description: 'Define the social network accounts on which to publish the task.',
            error: 'An error occurred while processing your request.',
            convert: {
                button: {
                    label: 'Request feedback'
                }
            }
        },
        filesPublicationRequired: {
            description: 'To validate the post, you must first validate a visual.'
        },
        hookChoicePublicationRequired: {
            description: 'To validate the post, you must choose the hook you wish to use.'
        },
        planning: {
            startTutorial: {
                description: 'Until your planning <br /> is generated, take a few <br />moments to discover <br />your schedule 💡',
                button: {
                    cancel: 'Skip',
                    start: 'Here we go!'
                }
            }
        },

        publicationPreview: {
            title: 'See the rendering of my publication',
            noNetwork: 'The publication networks could not be determined.',
            noHook: 'Unable to determine preview for this network.',
            header: {
                linkedin: {
                    carousel: {
                        title: 'Carousel name',
                        countElements: '{ count } pages'
                    }
                }
            },
            hook: {
                showMore: {
                    facebook: 'See more',
                    instagram: '... more',
                    linkedin: '... more'
                }
            },
            identity: {
                subscriber: '{ count } subscribers'
            },
            likes: {
                action: {
                    facebook: 'Like',
                    instagram: 'Like',
                    linkedin: 'Like'
                }
            },
            comments: {
                action: {
                    facebook: 'Comment',
                    instagram: 'Add a comment...',
                    linkedin: 'Comment'
                },
                counter: {
                    facebook: '{ count } comments',
                    instagram: 'Show all { count } comments',
                    linkedin: '{ count } comments'
                }
            },
            shares: {
                action: {
                    facebook: 'Share',
                    linkedin: 'Repost'
                },
                counter: {
                    facebook: '{ count } shares'
                }
            },
            sends: {
                action: {
                    linkedin: 'Send'
                }
            }
        },

        list: {
            firstTime: {
                title: 'To create your first post...',
                selectTask: 'Select a post from the list\nto edit or schedule it',
                schedule: 'Once you are done editing,\nclick on "Schedule"!',
                button: {
                    close: {
                        label: 'Got it!'
                    }
                }
            },
            generateNewIdeas: {
                title: 'Generation of new ideas',
                generating: 'It may take a few moments',
                counter: 'Ideas generated: { count } / { total }'
            },
            generateNewIdeasSettings: {
                title: 'New ideas generation settings',
                button: {
                    random: {
                        label: 'Generate randomly'
                    },
                    custom: {
                        label: 'Choose your subjects'
                    }
                }
            }
        },

        boostPublication: {
            facebook: {
                title: 'Facebook or Instagram Post Boost',
                loadBusinessAccountsError: 'Your Business accounts could not be retrieved.',
                loadAdvertAccountsError: 'Your advert accounts could not be retrieved.',
                advertCreated: 'The advert has been set up on your advert account. You should be able to edit it from your Business account.',
                form: {
                    error: 'An error occurred while saving the advertisement.',
                    fields: {
                        businessAccount: 'Business Account',
                        advertAccount: 'Advertising Account',
                        publication: 'Page publication to promote',
                        beginAt: 'Campaign start Date',
                        endAt: 'Campaign end Date',
                        dailyBudget: 'Daily budget',
                        ageMin: 'Minimum age',
                        ageMax: 'Maximum age',
                        gender: 'Target gender',
                        country: 'Target country',
                        objective: 'Objective',
                        cities: 'Cities to target',
                        interests: 'Interests to target',
                    },
                    city: {
                        placeholder: 'Search a city',
                    },
                    interest: {
                        placeholder: 'Search an interest',
                    },
                    gender: {
                        all: 'All',
                        male: 'Male',
                        female: 'Female'
                    },
                    objective: {
                        outcomeAwareness: 'Brand awareness',
                        outcomeEngagement: 'Engagement',
                        outcomeLeads: 'Lead generation',
                        outcomeTraffic: 'Traffic generation'
                    }
                }
            }
        }
    },

    ai: {
        // Initialisation de l'activation de l'Intelligence Artificielle
        init: {
            title: 'Congratulations and very happy to see you among us! 🥳',
            description: 'You have a choice : ask the AI Tookano to generate your schedule of posts or ask for the creation of publications by our community managers.',
            savingError: 'An error occurred during recording.',
            waitingMessage: 'Please wait a few moments, the Tookano AI is analyzing your website. In a few seconds the “Go” button will appear.',
            choices: {
                enable: {
                    label: 'Go !'
                },
                disable: {
                    label: 'I request the creation of customized posts'
                }
            },
            goToHome: {
                label: 'Go to Dashboard'
            }
        },
        // Validation des données issues de l'IA
        validationData: {
            title: 'Validate your information',
            description: 'We seem to know each other a little, don\'t we? 😋<br /> Has the AI {applicationName} understood you correctly?',
            loadFormatsError: 'An error occurred while loading the data.',
            subjects: {
                description: 'Last step, validate the subjects to generate your posts'
            }
        },
        // Définition du schéma des produits récupérés depuis une URL
        productsSchema: {
            title: 'Products match fields',
            description: 'Indicate a correspondence for each field in your file.'
        },
        // En attente des sujets de publication
        searchingSubjects: {
            title: 'Preparing your schedule',
            description: 'We\'re looking for publication topics for the coming weeks. You will be notified to validate or modify them.',
            button: {
                close: {
                    label: 'Go to Dashboard'
                }
            }
        },
        // Validation des sujets de publication
        subjectsValidation: {
            title: 'Validation of your publication topics',
            loadingAIThematicsError: 'An error occurred while loading the themes.',
            loadingAIAudiencesError: 'An error occurred while loading targets.',
            loadingFormatsError: 'An error occurred while loading formats.',
            requiredCreditsSubscription: {
                message: 'You must now be a subscriber to generate the rest of your schedule.',
                buttons: {
                    help: 'Need to exchange',
                    demo: 'Need a demo'
                }
            }
        },
        // Régénération d'un sujet par l'IA
        regenerationSubjectConfirmation: {
            title: 'Regeneration of a topic',
            credits: '0 credits are required to regenerate the subject name. | 1 credit is required to regenerate the subject name. | { count } credits are necessary in order to regenerate the name of the topic.',
            confirm: 'Are you sure you want to regenerate the topic { subject } ?',
            error: 'The topic could not be regenerated.'
        },
        // Planning en cours de génération
        planningComputing: {
            title: 'Your schedule is being created',
            description: 'The AI Tookano is building your schedule. It will be available soon. It may take a few minutes...',
            alert: {
                title: '{ user } you\'ll be alerted as soon as the schedules have been created in full.',
                description: 'However, the first posts will appear in your interface after validating the topics.'
            }
        },
        // Informations après la demande de génération d'un planning
        planningGeneratingInformations: {
            about: 'The AI { applicationName } is generating your topics.',
            mail: 'You will receive an email to validate them in a few minutes.',
            instruction: 'You can also find them by clicking on the "Validate my subjects" button.'
        },
        // Paramètre de l'IA pour le client connecté
        settings: {
            title: 'Editorial Line',
            description: 'The IA { applicationName } generated an editorial line based on the following parameters. You can modify them !'
        },
        // Style rédactionnel
        writingStyle: {
            title: 'Writing Style',
            summary: {
                title: 'Editorial style summary',
                informations: 'Here you\'ll find the writing styles that will be used to write your posts. You can modify them at any time to generate your future posts.'
            },
            noNetwork: 'You have not linked any social network to your account.',
            network: {
                prerequisites: {
                    about: 'Before suggesting writing styles, are you more like:',
                    error: 'An error occurred while generating the writing style.',
                    fields: {
                        formality: 'Formal / Informal',
                        pronouns: 'Pronouns',
                        languageRegister: 'Language register',
                        tones: 'Tones'
                    }
                },
                post: {
                    categoryTitle: 'Post type: { category }',
                    explications: 'Among the post examples below, select one by clicking the Next button. The post will be used to define the writing style for the "post { category }" category. You can modify the content by clicking on a caption.',
                    saveChoice: {
                        error: 'An error occurred while saving your choice.',
                        button: {
                            label: 'Validate this legend'
                        }
                    }
                },
                summary: {
                    title: {
                        style: 'Writing style',
                        post: 'Post example'
                    }
                }
            }
        },
        // Informations manquantes
        missingInformations: {
            title: 'Missing informations',
            description: 'An activity description is required to generate a schedule.',
            button: {
                goToSettings: {
                    label: 'Complete my profile'
                }
            }
        },

        editPostImage: {
            title: 'Editing the "{ title }" image',
        },
        addPostImages: {
            title: 'Add images'
        },
        removePostImage: {
            confirmation: {
                message: 'Are you sure you want to delete this image?'
            }
        },

        thematic: {
            regeneration: {
                confirmation: {
                    message: 'Are you sure you want to regenerate the thematic { thematic }? The subjects within this thematic will also be regenerated, and you will not be able to use the old subjects.',
                    error: 'An error occurred while regenerating the thematic { thematic }.'
                }
            }
        }
    },

    graphicalLineTemplate: {
        /* Sélection d'une charte graphique */
        list: {
            title: 'Edit a chart',
            empty: 'No graphic chart is available',
            editVisualButton: {
                label: 'Edit the visual'
            }
        },
        editDefaultTemplatesByCategory: {
            title: 'Your { category } Graphic Charts',
            description: 'Select your graphic charts for your { category } posts.<br />A maximum of 3 per post type. These graphic charts will be automatically incorporated when your monthly editorial calendar is generated.'
        }
    },

    themes: {
        list: {
            title: 'List of themes',
            empty: 'No themes found.'
        },
        edit: {
            title: 'Edition of the { name } theme'
        },
        add: {
            title: 'Add a theme'
        },
        remove: {
            error: 'An error occurred while deleting the theme.',
            message: 'Are you sure you want to delete theme { theme }?'
        }
    },

    agencyCustomer: {
        enableCustomer: {
            title: 'Activating a customer account'
        },
        editCustomer: {
            title: 'Editing customer account { name }'
        }
    },

    requiredPaymentInformations: {
        title: 'Payment information required'
    },

    enableTrialPeriod: {
        title: 'Activation of the trial period',
        description: 'To activate your { duration } days trial, we need your bank details. You will not be charged during your trial period, nor if you wish to cancel it. You can end your trial at any time from the <a href="{ accountUrl }" title="">My Account</a> page. If you do not cancel your trial, a monthly subscription of { price } (excluding VAT) will be charged each month until you cancel. An email will be sent to { email } one week before the end of the trial period, allowing you to cancel it if you wish.',
        error: 'An error occurred during the activation of your trial period.'
    },
    repositoryFile: {
        add: {
            title: 'Add a file to the directory'
        },
        edit: {
            title: 'Editing the file { name }'
        }
    }
};
